import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DelegatePersistLayoutReduxService } from './delegate-persist-layout-redux.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [DelegatePersistLayoutReduxService],
})
export class DynamicLayoutReduxModule {}
